import { Badge } from '@bambi/component-library/src/components/Badge/Badge';

import { defaultCurrencyFormat } from 'src/common/defaultCurrencyFormat';

export const EstimatedRevenueBadge = ({ revenue }: { revenue: number }) => {
  return (
    <div className="ml-1" data-testid="assignment-estimated-revenue">
      <Badge label={defaultCurrencyFormat(revenue, false)} color="green" />
    </div>
  );
};
